import React, { useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
  VStack,
} from '@chakra-ui/react'
import { faCreditCard, faUser } from '@fortawesome/free-regular-svg-icons'
import { faSearch, faUserPlus, faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../../../api/repository/Repository'
import Table from '../../../../components/Table/Table'
import Toast from '../../../../components/Toast/Toast'
import NumberBody from '../../../../components/Toast/ToastContents/NumberBody'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { nnColumns } from './temporalData'
import useOrder from '../../../../utils/hooks/useOrder/useOrder'

export default function NoNominative() {
  const { orderAsc, orderBy, onSort } = useOrder()

  const navigate = useNavigate()
  const { texts } = useLabels()
  const [data, setData] = useState()
  const [accounts, setAccounts] = useState([])
  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({
    actualPage: 1,
    nEmpleadosPagina: 30,
    totalPages: 0,
  })
  const handleGetData = async () => {
    const response = await REPOSITORY.wsEmpresa.company.getEmployees()
    setData(response)
  }

  const handleAccounts = useCallback(
    async (newPage) => {
      let sort = {}

      if (orderBy) {
        if (orderBy === 'NOMBRE') {
          sort = {
            sOrderby: 'sNombre',
            bAsc: orderAsc,
          }
        } else if (orderBy === 'RUT') {
          sort = {
            sOrderby: 'sEmpleado',
            bAsc: orderAsc,
          }
        } else if (orderBy === 'DATE') {
          sort = {
            sOrderby: 'dFechaCreacion',
            bAsc: orderAsc,
          }
        }
      }

      const dataNN = await REPOSITORY.wsEmpresa.employees.accountsRequested({
        sTipoEmpleado: 'NN',
        sBusqueda: search.trim(),
        nPagina: newPage ?? 1,
        nEmpleadosPagina: 20,
        bAsc: false,
        ...sort,
      })
      setPagination((prevState) => ({
        ...prevState,
        actualPage: dataNN.nPagina,
        totalPages: dataNN.nPaginasTotal,
      }))
      setAccounts(dataNN.DatosCuentaSolicitada)
    },
    [search, orderAsc, orderBy],
  )
  const handleChangeSearch = (event) => {
    setSearch(event.target.value)
  }
  const handleClearSearch = () => {
    setSearch('')
    handleAccounts(1)
  }
  const handleChangePage = (newPage) => {
    setPagination((prevState) => ({ ...prevState, actualPage: newPage }))
  }
  const handleSearch = () => {
    handleAccounts(1)
  }
  useEffect(() => {
    handleAccounts(pagination.actualPage)
  }, [pagination.actualPage, orderAsc, orderBy])

  useEffect(() => {
    handleGetData()
  }, [])

  return (
    <Flex direction="column" mb="80px">
      <Box>
        <UnderlineHeading text={texts.resume} variant="h5" />
      </Box>
      <HStack mt="44px" spacing="16px" justifyContent="flex-start">
        <Box>
          <Toast variant="gray">
            <NumberBody
              title="Número de colaboradores"
              notCurrency
              number={Number(data?.lCantEmpleado[0]?.sEmpleado_NO) || 0}
              icon={faUser}
            />
          </Toast>
        </Box>
        <Box>
          <Toast variant="gray">
            <NumberBody
              title="Número de bolsillos No Nominativos"
              notCurrency
              number={Number(data?.lCantEmpleado[0]?.sEmpleado_NN) || 0}
              icon={faCreditCard}
            />
          </Toast>
        </Box>
      </HStack>
      <VStack alignItems="flex-start" mt="32px">
        <Box mb={'24px'}>
          <UnderlineHeading text={'Acciones'} variant="h5" />
        </Box>
        <Box h="66px" w="320px">
          <Button
            variant="secondary"
            borderRadius="6px"
            onClick={() => navigate('account-request')}
          >
            <HStack>
              <FontAwesomeIcon icon={faUserPlus} />
              <Text variant="semibold" color="#FFFFFF">
                {texts.account_request}
              </Text>
            </HStack>
          </Button>
        </Box>
      </VStack>
      <Box mb={'24px'}>
        <UnderlineHeading text={'Últimos bolsillos creados'} variant="h5" />
      </Box>
      <VStack>
        <HStack width={'100%'}>
          <Box>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <FontAwesomeIcon icon={faSearch} />
              </InputLeftElement>
              <Input
                placeholder="Ingresa RUT"
                value={search}
                onChange={handleChangeSearch}
              />
              {search.length > 0 && (
                <InputRightElement
                  cursor={'pointer'}
                  onClick={handleClearSearch}
                >
                  <FontAwesomeIcon icon={faX} />
                </InputRightElement>
              )}
            </InputGroup>
          </Box>
          <Box>
            <Button onClick={handleSearch} variant={'ghost'}>
              Buscar
            </Button>
          </Box>
        </HStack>
        <Table
          orderAsc={orderAsc}
          orderBy={orderBy}
          onSort={onSort}
          data={accounts}
          columns={nnColumns}
          paginationProps={{
            ...pagination,
            handlePageChange: handleChangePage,
          }}
          withPagination
        />
      </VStack>
    </Flex>
  )
}
